var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4366 11.1094H6.72331L14.9311 3.98438C15.0624 3.86953 14.9827 3.65625 14.8092 3.65625H12.735C12.6436 3.65625 12.5569 3.68906 12.4889 3.74766L3.6319 11.4328C3.55078 11.5031 3.48573 11.5901 3.44114 11.6877C3.39655 11.7854 3.37347 11.8915 3.37347 11.9988C3.37347 12.1062 3.39655 12.2123 3.44114 12.3099C3.48573 12.4076 3.55078 12.4945 3.6319 12.5648L12.5405 20.2969C12.5757 20.3273 12.6178 20.3438 12.6624 20.3438H14.8069C14.9803 20.3438 15.06 20.1281 14.9288 20.0156L6.72331 12.8906H20.4366C20.5397 12.8906 20.6241 12.8062 20.6241 12.7031V11.2969C20.6241 11.1937 20.5397 11.1094 20.4366 11.1094Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f62afab22ed580d80b03afd1bdfcba05.svg";
export { ForwardRef as ReactComponent };